export default __webpack_public_path__ + "static/media/cincinnatiBengals@2x.597357c8.jpg";